import { Component, Input, ViewChild } from '@angular/core';
import { Content, NavParams } from 'ionic-angular';
import { MenuControl } from '../../providers/menu';

@Component({
  selector: 'app-no-state',
  templateUrl: 'no-state.html'
})
export class NoStateComponent {

  @ViewChild(Content) content: Content;

  @Input() configColor: any;

  constructor(
    private menuControl: MenuControl,
    private navParams: NavParams
  ) { }

  imageResize() {
    if (this.content) this.content.resize();
  }

  ionViewDidEnter() {
    this.menuControl.validateMenu(this.navParams);
  }
}



// WEBPACK FOOTER //
// ./src/components/no-state/no-state.ts